import { Alert, Button, Col, Image, InputNumber, Row, Tag, Tooltip } from 'antd'
import { minBy } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Item } from '../../models/productQuery'
import { ProductInfo } from '../../models/shoppingCartItem'
import { productsData } from '../../redux/reducers/product_reducer'
import { useAppDispatch, useAppSelector } from '../../redux/reduxHooks'
import { priceTirePopup } from './commonFunc'
import AttributesProduct from './productAttr'
import { PriceTypes, PriceTypes_en } from '../../data/priceTypes.enum'
import { expirationConvert } from '../../utils/ExpirationConvert'
import api from '../../config/api'
import { FormattedMessage } from 'react-intl'

const Box = styled.div`
  .ant-input-number-lg input {
    height: 45px;
  }
`
const CardStyle = styled.div<{ choose: number }>`
  position: relative;
  transition: all 0.5s ease;
  ::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    border: ${(props) => (props.choose ? '18px solid orange' : 'none')};
    border-top-color: transparent;
    border-left-color: transparent;
    z-index: 1000;
  }
  ::after {
    content: '';
    width: 7px;
    height: 14px;
    position: absolute;
    right: 6px;
    bottom: 0.5rem;
    border: ${(props) => (props.choose ? '2px solid white' : 'none')};
    border-top-color: transparent;
    border-left-color: transparent;
    transform: rotate(45deg);
    z-index: 1000;
  }
  border-color: ${(props) => (props.choose ? 'orange' : 'lightgrey')};
  :hover {
    cursor: pointer;
  }
`
const Img = styled.img`
  object-fit: cover;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const ImageStyle = styled(Image) <{ choose: number }>`
  border: ${(props) => (props.choose ? '1px solid orange' : '1px solid lightgrey')};
  object-fit: cover;
`

interface Props {
  quantity: (value: number) => void
  num: number
  finished: (productId: number, skuId: number) => void
}
const GroupedProducts = (props: Props) => {
  const { quantity, num, finished } = props
  const [isSelect, setIsSelect] = useState<number>()
  const [defaultChoose, setDefaultChoose] = useState<ProductInfo>()
  const [selectedProduct, setSelectedProduct] = useState<ProductInfo>()
  const [selectedItem, setSelectedItem] = useState<Item>()
  const [showAttrComponent, setShowAttrComponent] = useState<boolean>()
  const [tirePrice, setTirePrice] = useState(0)
  const [hasItemInItemList, setHasItemInItemList] = useState(true)
  const { groupData: data, selectedGroupData: originalData } = useAppSelector(productsData)
  const dispatch = useAppDispatch()

  useEffect(() => {
    const lowestPriceProduct = minBy(data, function (item) {
      return item.finalPrice
    })
    if (!lowestPriceProduct) return
    setDefaultChoose(lowestPriceProduct)
    setShowAttrComponent(lowestPriceProduct.typeId === 'variant')
    setSelectedProduct(lowestPriceProduct)
    quantity(lowestPriceProduct.items[0].unitMin)
  }, [data, dispatch])

  useEffect(() => {
    if (!selectedItem) {
      return
    }
    quantity(selectedItem.unitMin)
  }, [selectedItem])

  const showPriceTire = useCallback(() => {
    if (selectedItem && selectedItem.priceTiers.length > 0) {
      return selectedItem.priceTiers.map((item, index) => <Tag key={index} color={'red'}>{`${item.unitMin}件起 $${item.price}`}</Tag>)
    } else if (selectedProduct?.items[0]?.priceTiers?.length > 0) {
      return selectedProduct?.items[0].priceTiers.map((item, index) => (
        <Tag key={index} color={'red'}>{`${item.unitMin} ${localStorage.getItem('lang') === 'zh-CN' ? '件起' : ' units '} $${item.price
          }`}</Tag>
      ))
    }
    return <></>
  }, [selectedItem])

  const imageUrl = (img) => {
    let url = img
    if (!!img && (img.slice(0, 7) == 'http://' || img.slice(0, 8) == 'https://'))
      url = img
    else
      url = `${api.cdn}/${img}?x-oss-process=style/640w`
    return url
  }

  return (
    <>
      <div style={{ marginTop: '15px' }}></div>
      <Row wrap={false}>
        <Col span={8}>
          <div style={{ position: 'relative', paddingTop: 'calc(100%)' }}>
            <Img src={`${imageUrl(originalData.image)}`} />
          </div>
          <div style={{ width: '25%', marginTop: '10px' }}>
            <div style={{ position: 'relative', paddingTop: 'calc(100%)' }}>
              <Img src={`${imageUrl(originalData.image)}`} />
            </div>
          </div>
        </Col>
        <Col span={15} offset={1}>
          <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '15px' }}>{originalData.name}</div>
          <Row style={{ marginRight: '15px', fontSize: '1.2rem', marginBottom: '15px' }}>
            <Col span={5}>商品</Col>
            <Col span={19}>{selectedProduct?.shippingName}</Col>
          </Row>

          <Row style={{ marginRight: '15px', fontSize: '1.2rem' }}>
            <Col span={5}>选择产品: </Col>
            <Col span={19}>
              <Row gutter={[16, 16]}>
                {data.map((item) => (
                  <Col span={6} key={item?.productId}>
                    <div>
                      {
                        <Row justify='space-between' align='middle'>
                          <Col style={{ width: '100%' }}>
                            <Tooltip title={item.shippingName}>
                              <CardStyle
                                choose={
                                  isSelect ? (item?.productId === isSelect ? 1 : 0) : item?.productId === defaultChoose?.productId ? 1 : 0
                                }
                                onClick={() => {
                                  setIsSelect(item?.productId)
                                  if (item.typeId === 'variant') {
                                    setShowAttrComponent(true)
                                    setSelectedProduct(item)
                                  } else {
                                    setSelectedProduct(item)
                                    setShowAttrComponent(false)
                                  }
                                }}
                              >
                                <ImageStyle
                                  choose={
                                    isSelect ? (item?.productId === isSelect ? 1 : 0) : item?.productId === defaultChoose?.productId ? 1 : 0
                                  }
                                  width='100%'
                                  height='5rem'
                                  preview={false}
                                  placeholder={true}
                                  alt='example'
                                  src={`${imageUrl(item?.image)}`}
                                  fallback='data:image/png;base64,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'
                                />
                              </CardStyle>
                            </Tooltip>
                          </Col>
                        </Row>
                      }
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          <div>
            {showAttrComponent && (
              <AttributesProduct
                showAttr={showAttrComponent}
                product={selectedProduct}
                setSelectedItemForOther={(item) => {
                  console.log(item)
                  setSelectedItem(item)
                }}
                tirePriceSet={(price) => {
                  setTirePrice(price)
                }}
                otherQuantity={num}
                hasItemInlist={(res) => {
                  setHasItemInItemList(res)
                }}
              />
            )}
          </div>
          <Row align='middle' style={{ marginTop: '15px' }}>
            <Col span={5}>
              <FormattedMessage id='amount' />
            </Col>

            <Col span={19}>
              <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
                <InputNumber
                  size='large'
                  formatter={(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => +value.replace(/\$\s?|(,*)/g, '')}
                  min={showAttrComponent ? selectedItem?.unitMin || 0 : selectedProduct?.items[0].unitMin || 0}
                  max={
                    showAttrComponent ? selectedItem?.unitMax || Number.MAX_VALUE : selectedProduct?.items[0].unitMax || Number.MAX_VALUE
                  }
                  value={num}
                  onChange={(value) => {
                    quantity(value)
                  }}
                />

                <span style={{ marginLeft: '15px' }}>
                  <FormattedMessage id='unit' />
                </span>
                {selectedItem?.unitMin > 1 && <span style={{ margin: '0 0.5rem' }}>Min: {selectedItem.unitMin}</span>}
                {!!selectedItem?.unitMax && <span style={{ margin: '0 0.5rem' }}>Max: {selectedItem.unitMax}</span>}
              </Box>
            </Col>
          </Row>
          <Row style={{ marginTop: '10px' }} align='middle'>
            <Col span={5}>
              <FormattedMessage id='stock' />:{' '}
            </Col>
            <Col>
              {showAttrComponent
                ? selectedItem?.stockVisible
                  ? selectedItem?.stock === 0
                    ? localStorage.getItem('lang') === 'zh-CN'
                      ? '补货中...'
                      : 'out of stock'
                    : selectedItem?.stock
                  : 'Infinity'
                : selectedProduct?.items[0].stockVisible
                  ? selectedProduct?.items[0].stock === 0
                    ? '补货中...'
                    : selectedProduct?.stock
                  : 'Infinity'}
            </Col>
            <Col offset={1}>{selectedItem?.stockLocationName}</Col>
          </Row>

          <Row style={{ marginTop: '10px' }} align='middle' gutter={[16, 48]}>
            <Col span={5}>
              <FormattedMessage id='price' />:
            </Col>
            <Col style={{ fontSize: '1.5rem', fontWeight: 700, display: 'flex', alignItems: 'center' }}>
              {localStorage.getItem('lang') === 'zh-CN'
                ? PriceTypes[selectedItem?.finalPriceType] !== '' && (
                  <span style={{ fontSize: '1rem', fontWeight: 700, color: 'red', marginRight: '0.5rem' }}>
                    ({PriceTypes[selectedItem?.finalPriceType]})
                  </span>
                )
                : PriceTypes_en[selectedItem?.finalPriceType] !== '' && (
                  <span style={{ fontSize: '1rem', fontWeight: 700, color: 'red', marginRight: '0.5rem' }}>
                    ({PriceTypes_en[selectedItem?.finalPriceType]})
                  </span>
                )}
              NZ$ {((showAttrComponent ? tirePrice : selectedProduct?.items[0].finalPrice) * num).toFixed(2)}
            </Col>
            <Col style={{ fontSize: '1rem', fontWeight: 700 }}>{showPriceTire()}</Col>
          </Row>
          <Row style={{ marginTop: '10px' }} align='middle' gutter={[16, 48]}>
            <Col span={5}>
              <div>
                <FormattedMessage id='expired' />:{' '}
              </div>
            </Col>
            <Col span={19}>
              {expirationConvert(showAttrComponent ? selectedItem?.expiration : selectedProduct?.items[0].expiration)}</Col>
          </Row>
          <Row style={{marginTop: '10px'}}>
            <Col span={5}></Col>
            <Col span={10} style={{ height: '100%' }}>
              <Button
                block
                style={{
                  background: (
                    hasItemInItemList && showAttrComponent
                      ? selectedItem?.enable && !(selectedItem?.stockVisible && selectedItem?.stock === 0)
                      : selectedProduct?.items[0].enable &&
                      !(selectedProduct?.items[0].stockVisible && selectedProduct?.items[0].stock === 0)
                  )
                    ? 'orange'
                    : '',
                  color: (
                    hasItemInItemList && showAttrComponent
                      ? selectedItem?.enable && !(selectedItem?.stockVisible && selectedItem?.stock === 0)
                      : selectedProduct?.items[0].enable &&
                      !(selectedProduct?.items[0].stockVisible && selectedProduct?.items[0].stock === 0)
                  )
                    ? 'white'
                    : '',
                  height: '100%',
                  backgroundColor: 'orange',
                  letterSpacing: localStorage.getItem('lang') === 'zh-CN' ? '0.5rem' : 0
                }}
                disabled={
                  !hasItemInItemList || showAttrComponent
                    ? !selectedItem?.enable || (selectedItem?.stockVisible && selectedItem?.stock === 0)
                    : !selectedProduct?.items[0].enable || (selectedProduct?.items[0].stockVisible && selectedProduct?.items[0].stock === 0)
                }
                onClick={() =>
                  finished(selectedProduct?.productId, showAttrComponent ? selectedItem?.skuId : selectedProduct?.items[0].skuId)
                }
              >
                <FormattedMessage id='purchase' />
              </Button>
            </Col>
            <Col offset={9}>{!hasItemInItemList && <Alert message='Sold Out' type='error' showIcon />}</Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default GroupedProducts
